module.exports = __webpack_public_path__ + "img/shoes.8e090653.svg";